import React from "react";
import {
    NONQUAL_ACCOUNTS,
    PRETAX_ACCOUNTS, ROTH_DESTINATION_INCREASING_PAYOUT_FIA, ROTH_DESTINATION_LEVEL_INCOME_FIA, ROTH_DESTINATION_RILA,
    ROTH_DESTINATION_ROTH_IRA,
    ROTH_DESTINATION_VOLATILITY_BUFFER_FIA,
    TAXFREE_ACCOUNTS
} from "../../shared/constants";
import {currencyFormatNoDecimals, formatNumberToPercentage} from "../../shared/shared";
import RoadmapOwnerCell from "./roadmapOwnerCell";

/*
	Roth IRA
	Volatility Buffer FIA
	Level Income FIA
	Increasing Payout FIA
	RILA
*/

const financialDataItemTHStyle = {
    padding: "0.5em"
};
const financialDataItemTDStyle = {
    padding: "0.5em",
    fontSize: "0.9em",
    textAlign: "center"
};
const financialDataItemStyle = {
    display: "inline-block",
    width: "150px",
    marginRight: "1em"
};
const financialDataItemLabelStyle = {
    display: "inline-block",
    marginRight: "1em"
};

const RothIRADetails = (props) => {

    const item = props.item;

    return  <tr style={{
        borderBottom: "1px solid #eee"
    }}>
        <td colSpan={7} style={{
            padding: "0.5em",
            fontSize: "0.7em"
        }}>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Stocks</label>
                <span>{item.stocks}%</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Bonds</label>
                <span>{item.bonds}%</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Cash</label>
                <span>{item.cash}%</span>
            </div>
        </td>
    </tr>
};

const VolatilityBufferFIADetails = (props) => {
    const item = props.item;

    return  <tr style={{
        borderBottom: "1px solid #eee"
    }}>
        <td colSpan={7} style={{
            padding: "0.5em",
            fontSize: "0.7em"
        }}>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Premium Bonus</label>
                <span>{formatNumberToPercentage(item.premiumBonus, 2)}</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Upside</label>
                <span>{item.upsideType} {item.upsideRate}%</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Downside</label>
                <span>{item.downsideType} {item.downsideRate}%</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Avg Return</label>
                <span>{item.averageReturn}%</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Std. Deviation</label>
                <span>{item.standardDeviation}%</span>
            </div>
        </td>
    </tr>
};

const LevelIncomeFIADetails = (props) => {
    const item = props.item;

    return  <tr style={{
        borderBottom: "1px solid #eee"
    }}>
        <td colSpan={7} style={{
            padding: "0.5em",
            fontSize: "0.7em"
        }}>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Premium Bonus</label>
                <span>{formatNumberToPercentage(item.premiumBonus, 2)}</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Hypothetical Index Return</label>
                <span>{formatNumberToPercentage(item.hypotheticalIndexReturn, 2)}</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Years of Deferral</label>
                <span>{item.yearsOfDeferral}</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Base Roll Up Rate</label>
                <span>{formatNumberToPercentage(item.baseRollUpRate, 2)}</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Benefit Base Bonus</label>
                <span>{formatNumberToPercentage(item.benefitBaseBonus, 2)}</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Payout Factors</label>
                <span>{formatNumberToPercentage(item.payoutFactors, 2)}</span>
            </div>
        </td>
    </tr>
};

const IncreasingPayoutDetails = (props) => {
    const item = props.item;

    return  <tr style={{
        borderBottom: "1px solid #eee"
    }}>
        <td colSpan={7} style={{
            padding: "0.5em",
            fontSize: "0.7em"
        }}>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Premium Bonus</label>
                <span>{formatNumberToPercentage(item.premiumBonus, 2)}</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Hypothetical Index Return</label>
                <span>{formatNumberToPercentage(item.hypotheticalIndexReturn, 2)}</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Years of Deferral</label>
                <span>{item.yearsOfDeferral}</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Base Roll Up Rate</label>
                <span>{formatNumberToPercentage(item.baseRollUpRate, 2)}</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Benefit Base Bonus</label>
                <span>{formatNumberToPercentage(item.benefitBaseBonus, 2)}</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Payout Factors</label>
                <span>{formatNumberToPercentage(item.payoutFactors, 2)}</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Growth Multiplier</label>
                <span>{item.growthMultiplier}%</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Stacking Multiplier</label>
                <span>{formatNumberToPercentage(item.stackingMultiplier, 2)}</span>
            </div>
        </td>
    </tr>
};

const RILADetails = (props) => {
    const item = props.item;

    return  <tr style={{
        borderBottom: "1px solid #eee"
    }}>
        <td colSpan={7} style={{
            padding: "0.5em",
            fontSize: "0.7em"
        }}>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Premium Bonus</label>
                <span>{formatNumberToPercentage(item.premiumBonus, 2)}</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Upside</label>
                <span>{item.upsideType} {item.upsideRate}%</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Downside</label>
                <span>{item.downsideType} {item.downsideRate}%</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Avg Return</label>
                <span>{item.averageReturn}%</span>
            </div>
            <div style={financialDataItemStyle}>
                <label style={financialDataItemLabelStyle}>Std. Deviation</label>
                <span>{item.standardDeviation}%</span>
            </div>
        </td>
    </tr>
}

const RothConversionDetails = (props) => {
    const dataItem = props.item;

    switch(dataItem.destination) {
        case ROTH_DESTINATION_ROTH_IRA: return <RothIRADetails {...props} />;
        case ROTH_DESTINATION_VOLATILITY_BUFFER_FIA: return <VolatilityBufferFIADetails {...props} />;
        case ROTH_DESTINATION_LEVEL_INCOME_FIA: return <LevelIncomeFIADetails {...props} />;
        case ROTH_DESTINATION_INCREASING_PAYOUT_FIA: return <IncreasingPayoutDetails {...props} />;
        case ROTH_DESTINATION_RILA: return <RILADetails {...props} />;
        default:
            return <RothIRADetails {...props} />
    }
}

export const RothConversion = (props) => {

    const subSectionStyle = { color: '#157ee8', margin: '25px 0', fontSize: "1em" }

    const getAccountsAccountText = (element) => {
        let typeMap = {};
        const options = props.accounts.filter(item => {
            return item.appliesTo === element.appliesTo && item.id != null;
        }).map((item) => {
            if (typeMap[element.appliesTo + item.taxType + item.value]) {
                typeMap[element.appliesTo + item.taxType + item.value].push(typeMap[element.appliesTo + item.taxType + item.value].length + 1);
            } else {
                typeMap[element.appliesTo + item.taxType + item.value] = [1];
            }
            return item;
        }).map((item) => {
            const option =
                item.taxType === "NON_QUALIFIED"
                    ? NONQUAL_ACCOUNTS.find((e) => e.value === item.accountType)
                    : item.taxType === "PRE_TAX"
                        ? PRETAX_ACCOUNTS.find((e) => e.value === item.accountType)
                        : TAXFREE_ACCOUNTS.find((e) => e.value === item.accountType);

            let text = "";
            if(option != undefined) {
                text = option.text + " - " + currencyFormatNoDecimals(item.value)
            }
            if (typeMap[element.appliesTo + item.taxType + item.value].length == 1 && typeMap[element.appliesTo + item.taxType + item.value][0] == 1) {
                typeMap[element.appliesTo + item.taxType + item.value].shift();
            } else if (typeMap[element.appliesTo + item.taxType + item.value].length > 0) {
                text = text + " - " + typeMap[element.appliesTo + item.taxType + item.value][0];
                typeMap[element.appliesTo + item.taxType + item.value].shift();
            }
            return { id: item.id, value: text };
        }).filter((item) => item.id === element.accountId);
        return options.length > 0 ? options[0].value : "";
    }

    return (<div>
        <h2 style={subSectionStyle}>Roth Conversion</h2>
        <table style={{
            width: "100%",
            borderCollapse: "collapse"
        }}>
            <thead>
                <tr style={{
                    backgroundColor: "#157ee8",
                    color: "white",
                }}>
                    <th style={financialDataItemTHStyle}>Transfer Account</th>
                    <th style={financialDataItemTHStyle}>Owner</th>
                    <th style={financialDataItemTHStyle}>Conversion Type</th>
                    <th style={financialDataItemTHStyle}>Numbers of Years</th>
                    <th style={financialDataItemTHStyle}>Start Year</th>
                    <th style={financialDataItemTHStyle}>Transfer Amount</th>
                </tr>
            </thead>
            <tbody>
                {props?.rothTransfers?.length > 0 && (
                    props.rothTransfers.map((item, idx) => {

                        const conversionType = { FIXED_AMOUNT: "Fixed", "ALL": "All" }

                        return <React.Fragment key={idx}><tr>
                            <td style={financialDataItemTDStyle}>{getAccountsAccountText(item)}</td>
                            <td style={financialDataItemTDStyle}><RoadmapOwnerCell item={item} /></td>
                            <td style={financialDataItemTDStyle}>{conversionType[item.conversionType]}</td>
                            <td style={financialDataItemTDStyle}>{item.noOfYears}</td>
                            <td style={financialDataItemTDStyle}>{item.transferStartYear}</td>
                            <td style={financialDataItemTDStyle}>{currencyFormatNoDecimals(item.transferAmount)}</td>
                        </tr>
                            <RothConversionDetails item={item} />
                        </React.Fragment>
                    }))}
            </tbody>
        </table>
    </div>)

}
